import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withKeys as _withKeys, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, withCtx as _withCtx, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "error-msg-wrap"
}
const _hoisted_2 = {
  class: "form-wrapper slide-up crm-form-wrapper",
  style: {"width":"1100px"}
}
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = {
  key: 0,
  class: "board-item-tags card-color-pop"
}
const _hoisted_5 = { class: "card-color-pop-head" }
const _hoisted_6 = { class: "crm-board-color-select" }
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "qc-item-wrap crm-item-wrap" }
const _hoisted_10 = { class: "crm-item-title-row" }
const _hoisted_11 = { class: "pb-more crm-item-more" }
const _hoisted_12 = ["aria-expanded"]
const _hoisted_13 = {
  key: 0,
  class: "crm-mirror-hint"
}
const _hoisted_14 = ["value"]
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "crm-mirror-hint" }
const _hoisted_17 = {
  key: 0,
  class: "crm-mirror-hint"
}
const _hoisted_18 = ["value"]
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "crm-mirror-hint" }
const _hoisted_21 = ["value"]
const _hoisted_22 = ["value"]
const _hoisted_23 = {
  key: 0,
  class: "customer-request-tags crm-item-chips"
}
const _hoisted_24 = {
  key: 1,
  class: "crm-item-mirrors"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "crm-item-actions" }
const _hoisted_29 = { class: "board-item-btns" }
const _hoisted_30 = {
  key: 0,
  class: "board-item-tags"
}
const _hoisted_31 = { class: "board-item-tags-tags" }
const _hoisted_32 = {
  key: 0,
  style: {"font-weight":"normal"}
}
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = {
  key: 0,
  class: "board-item-tags"
}
const _hoisted_35 = {
  key: 0,
  class: "board-item-tags"
}
const _hoisted_36 = {
  key: 0,
  style: {"margin-top":"10px","font-weight":"normal"}
}
const _hoisted_37 = ["value"]
const _hoisted_38 = { key: 3 }
const _hoisted_39 = { class: "board-tip-tap" }
const _hoisted_40 = { style: {"margin-top":"10px","display":"flex"} }
const _hoisted_41 = { key: 4 }
const _hoisted_42 = {
  key: 0,
  class: "board-tip-tap"
}
const _hoisted_43 = { style: {"margin-top":"10px","display":"flex"} }
const _hoisted_44 = { class: "crm-checklist-head" }
const _hoisted_45 = ["onUpdate:modelValue", "onChange"]
const _hoisted_46 = { class: "board-item-btns" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 0,
  class: "crm-checklist-progress"
}
const _hoisted_49 = ["onUpdate:modelValue", "onChange"]
const _hoisted_50 = ["onUpdate:modelValue", "onChange"]
const _hoisted_51 = { class: "crm-checklist-date" }
const _hoisted_52 = ["onUpdate:modelValue", "onChange"]
const _hoisted_53 = {
  key: 0,
  class: "crm-checklist-date-ph",
  "aria-hidden": "true"
}
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["onSubmit"]
const _hoisted_56 = ["id", "onUpdate:modelValue", "onKeyup"]
const _hoisted_57 = { class: "inline-plus-input crm-checklist-add" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { class: "crm-comment-section" }
const _hoisted_60 = { style: {"display":"flex"} }
const _hoisted_61 = {
  key: 0,
  class: "crm-comments"
}
const _hoisted_62 = ["onSubmit"]
const _hoisted_63 = ["onUpdate:modelValue"]
const _hoisted_64 = { style: {"display":"flex"} }
const _hoisted_65 = ["innerHTML"]
const _hoisted_66 = { class: "crm-comment-meta" }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { class: "crm-comment-date" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = ["onClick"]
const _hoisted_71 = { class: "crm-item-section-head" }
const _hoisted_72 = { class: "board-item-btns" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { class: "crm-item-file-list" }
const _hoisted_75 = ["href"]
const _hoisted_76 = ["href"]
const _hoisted_77 = ["onClick"]
const _hoisted_78 = { class: "crm-item-section-head crm-item-activity-head" }
const _hoisted_79 = { class: "board-item-btns" }
const _hoisted_80 = {
  key: 2,
  class: "board-activity-list crm-item-activity"
}
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { class: "board-activity-date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_tip_tap = _resolveComponent("tip-tap")!
  const _component_forge_card_steps = _resolveComponent("forge-card-steps")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_drop_file = _resolveComponent("drop-file")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!

  return (_ctx.isLoaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.formData.CardColor == '#000000' ? 'card-color-cover card-color-cover-black' : 'card-color-cover'),
            style: _normalizeStyle(_ctx.formData.CardColor ? 'background:'+_ctx.formData.CardColor : '')
          }, [
            _createElementVNode("div", {
              class: "card-color-cover-edit",
              title: "Card color",
              onClick: _cache[0] || (_cache[0] = () => { _ctx.showEditColorCover = !_ctx.showEditColorCover })
            }, [
              _createVNode(_component_svg_icon, { icon: "image" })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                type: "button",
                class: "form-close-x",
                title: "Close",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
              }, "×")
            ]),
            (_ctx.showEditColorCover)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[66] || (_cache[66] = _createElementVNode("b", null, "Card color", -1)),
                    _createElementVNode("span", {
                      class: "board-item-tags-close",
                      onClick: _cache[2] || (_cache[2] = () => { _ctx.showEditColorCover = false })
                    }, [
                      _createVNode(_component_svg_icon, { icon: "x" })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.CardColor) = $event)),
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.fieldChange(null)))
                    }, [
                      _cache[67] || (_cache[67] = _createElementVNode("option", { value: null }, "No color", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.colorPalette, (color, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: i,
                          value: color.hex
                        }, _toDisplayString(color.label), 9, _hoisted_7))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, _ctx.formData.CardColor]
                    ]),
                    _createElementVNode("input", {
                      type: "color",
                      value: _ctx.formData.CardColor || '#DDDDDD',
                      onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.setCustomCardColor && _ctx.setCustomCardColor(...args))),
                      title: "Custom color"
                    }, null, 40, _hoisted_8)
                  ]),
                  (_ctx.formData.CardColor)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "card-color-pop-clear",
                        onClick: _cache[6] || (_cache[6] = _withModifiers(() => { _ctx.formData.CardColor = null; _ctx.showEditColorCover = false; _ctx.fieldChange(null); }, ["prevent"]))
                      }, "Remove color"))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 6),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("textarea", {
                  ref: "titleInput",
                  rows: "1",
                  class: "h3-text-input crm-item-title",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.Name) = $event)),
                  placeholder: "Enter Name",
                  onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.fitTitle())),
                  onKeydown: _cache[9] || (_cache[9] = _withKeys(_withModifiers(($event: any) => (($event.target as HTMLTextAreaElement).blur()), ["prevent"]), ["enter"])),
                  onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.titleChange()))
                }, null, 544), [
                  [_vModelText, _ctx.formData.Name]
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "crm-item-kebab",
                    "aria-haspopup": "menu",
                    "aria-expanded": _ctx.showCardMenu,
                    "aria-label": "Card actions",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showCardMenu = !_ctx.showCardMenu))
                  }, [
                    _createVNode(_component_svg_icon, { icon: "dots" })
                  ], 8, _hoisted_12),
                  (_ctx.showCardMenu)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "pb-menu",
                        role: "menu",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showCardMenu = false))
                      }, [
                        (!_ctx.inInbox)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "pb-mi",
                              role: "menuitem",
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openMirror()))
                            }, "Mirror to Another Board"))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          class: "pb-mi",
                          role: "menuitem",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.openMove()))
                        }, "Move to Another Board"),
                        _createElementVNode("button", {
                          type: "button",
                          class: "pb-mi",
                          role: "menuitem",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.openClone()))
                        }, "Clone"),
                        _cache[68] || (_cache[68] = _createElementVNode("div", { class: "pb-sep" }, null, -1)),
                        _createElementVNode("button", {
                          type: "button",
                          class: "pb-mi pb-mi-danger",
                          role: "menuitem",
                          onClick: _cache[15] || (_cache[15] = () => { _ctx.showConfirmDelete = true; })
                        }, _toDisplayString(_ctx.formData.HomeBoard ? 'Remove From This Board' : 'Delete Card'), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showMirror)
                    ? (_openBlock(), _createElementBlock("form", {
                        key: 1,
                        class: "board-item-tags crm-mirror-pop",
                        onSubmit: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.submitMirror()), ["prevent"]))
                      }, [
                        _createElementVNode("div", {
                          class: "board-item-tags-close",
                          onClick: _cache[17] || (_cache[17] = () => { _ctx.showMirror = false })
                        }, [
                          _createVNode(_component_svg_icon, { icon: "x" })
                        ]),
                        _cache[71] || (_cache[71] = _createElementVNode("div", { class: "crm-mirror-hint" }, "Show this card on another board too. Edits on either board show on both.", -1)),
                        (!_ctx.mirrorTargets.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, "There are no other boards to mirror it onto."))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _cache[69] || (_cache[69] = _createElementVNode("div", { class: "crm-item-label" }, "Board", -1)),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.mirrorSlug) = $event)),
                                onChange: _cache[19] || (_cache[19] = () => { _ctx.mirrorColumn = _ctx.mirrorColumns[0] || '' })
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mirrorTargets, (board) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: board.Slug,
                                    value: board.Slug
                                  }, _toDisplayString(board.Name), 9, _hoisted_14))
                                }), 128))
                              ], 544), [
                                [_vModelSelect, _ctx.mirrorSlug]
                              ]),
                              _cache[70] || (_cache[70] = _createElementVNode("div", { class: "crm-item-label" }, "Column", -1)),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.mirrorColumn) = $event))
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mirrorColumns, (column) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: column,
                                    value: column
                                  }, _toDisplayString(column), 9, _hoisted_15))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, _ctx.mirrorColumn]
                              ]),
                              _createElementVNode("button", {
                                class: _normalizeClass(_ctx.mirroring ? 'btn disable-button' : 'btn')
                              }, "Mirror", 2)
                            ], 64))
                      ], 32))
                    : _createCommentVNode("", true),
                  (_ctx.showMove)
                    ? (_openBlock(), _createElementBlock("form", {
                        key: 2,
                        class: "board-item-tags crm-mirror-pop",
                        onSubmit: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (_ctx.submitMove()), ["prevent"]))
                      }, [
                        _createElementVNode("div", {
                          class: "board-item-tags-close",
                          onClick: _cache[22] || (_cache[22] = () => { _ctx.showMove = false })
                        }, [
                          _createVNode(_component_svg_icon, { icon: "x" })
                        ]),
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.formData.HomeBoard ? `Move this mirror to another board. The card stays on ${_ctx.formData.HomeBoard.Name}.` : 'Move this card to another board, with its comments, files and activity.'), 1),
                        (!_ctx.moveTargets.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, "There are no other boards to move it to."))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _cache[72] || (_cache[72] = _createElementVNode("div", { class: "crm-item-label" }, "Board", -1)),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.moveSlug) = $event)),
                                onChange: _cache[24] || (_cache[24] = () => { _ctx.moveColumn = _ctx.moveColumns[0] || '' })
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moveTargets, (board) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: board.Slug,
                                    value: board.Slug
                                  }, _toDisplayString(board.Name), 9, _hoisted_18))
                                }), 128))
                              ], 544), [
                                [_vModelSelect, _ctx.moveSlug]
                              ]),
                              _cache[73] || (_cache[73] = _createElementVNode("div", { class: "crm-item-label" }, "Column", -1)),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.moveColumn) = $event))
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moveColumns, (column) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: column,
                                    value: column
                                  }, _toDisplayString(column), 9, _hoisted_19))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, _ctx.moveColumn]
                              ]),
                              _createElementVNode("button", {
                                class: _normalizeClass(_ctx.moving ? 'btn disable-button' : 'btn')
                              }, "Move", 2)
                            ], 64))
                      ], 32))
                    : _createCommentVNode("", true),
                  (_ctx.showClone)
                    ? (_openBlock(), _createElementBlock("form", {
                        key: 3,
                        class: "board-item-tags crm-mirror-pop",
                        onSubmit: _cache[33] || (_cache[33] = _withModifiers(($event: any) => (_ctx.submitClone()), ["prevent"]))
                      }, [
                        _createElementVNode("div", {
                          class: "board-item-tags-close",
                          onClick: _cache[27] || (_cache[27] = () => { _ctx.showClone = false })
                        }, [
                          _createVNode(_component_svg_icon, { icon: "x" })
                        ]),
                        (_ctx.cloned)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_20, "Cloned to " + _toDisplayString(_ctx.cloned.Name) + ", in " + _toDisplayString(_ctx.cloned.Column) + ".", 1),
                              (_ctx.canOpenBoard(_ctx.cloned))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "btn",
                                    onClick: _cache[28] || (_cache[28] = _withModifiers(($event: any) => (_ctx.openOnBoard(_ctx.cloned, _ctx.cloned.ID)), ["prevent"]))
                                  }, "Open Clone"))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _cache[74] || (_cache[74] = _createElementVNode("div", { class: "crm-mirror-hint" }, "Make a new card from this one, with its checklist, tags, dates and files. Checks are cleared, and comments stay here.", -1)),
                              _cache[75] || (_cache[75] = _createElementVNode("div", { class: "crm-item-label" }, "Name", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "input-slim",
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.cloneName) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.cloneName]
                              ]),
                              _cache[76] || (_cache[76] = _createElementVNode("div", { class: "crm-item-label" }, "Board", -1)),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.cloneSlug) = $event)),
                                onChange: _cache[31] || (_cache[31] = () => { _ctx.cloneColumn = _ctx.cloneColumns[0] || '' })
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cloneTargets, (board) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: board.Slug,
                                    value: board.Slug
                                  }, _toDisplayString(board.Name), 9, _hoisted_21))
                                }), 128))
                              ], 544), [
                                [_vModelSelect, _ctx.cloneSlug]
                              ]),
                              _cache[77] || (_cache[77] = _createElementVNode("div", { class: "crm-item-label" }, "Column", -1)),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.cloneColumn) = $event))
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cloneColumns, (column) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: column,
                                    value: column
                                  }, _toDisplayString(column), 9, _hoisted_22))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, _ctx.cloneColumn]
                              ]),
                              _createElementVNode("button", {
                                class: _normalizeClass(_ctx.cloning ? 'btn disable-button' : 'btn')
                              }, "Clone", 2)
                            ], 64))
                      ], 32))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.displayTags.length || _ctx.dateInfo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    (_ctx.dateInfo)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(_ctx.dateInfo.Overdue ? 'crm-item-date crm-item-date-overdue' : 'crm-item-date')
                        }, [
                          _createVNode(_component_svg_icon, { icon: "clock" }),
                          _createTextVNode(_toDisplayString(_ctx.dateInfo.DateDisplay), 1)
                        ], 2))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayTags, (tag, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        style: _normalizeStyle('background:'+tag.color)
                      }, _toDisplayString(tag.name), 5))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.HomeBoard || _ctx.otherMirrorBoards.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createVNode(_component_svg_icon, { icon: "copy" }),
                    _createElementVNode("span", null, [
                      (_ctx.formData.HomeBoard)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[78] || (_cache[78] = _createTextVNode("Mirrored from ", -1)),
                            (_ctx.canOpenBoard(_ctx.formData.HomeBoard))
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  onClick: _cache[34] || (_cache[34] = _withModifiers(($event: any) => (_ctx.openOnBoard(_ctx.formData.HomeBoard)), ["prevent"]))
                                }, _toDisplayString(_ctx.formData.HomeBoard.Name), 1))
                              : (_openBlock(), _createElementBlock("b", _hoisted_25, _toDisplayString(_ctx.formData.HomeBoard.Name), 1))
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.otherMirrorBoards.length)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.formData.HomeBoard ? ', also on ' : 'Also on '), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherMirrorBoards, (board, i) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: board.Slug
                              }, [
                                _createTextVNode(_toDisplayString(i ? ', ' : ''), 1),
                                (_ctx.canOpenBoard(board))
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      onClick: _withModifiers(($event: any) => (_ctx.openOnBoard(board)), ["prevent"])
                                    }, _toDisplayString(board.Name), 9, _hoisted_26))
                                  : (_openBlock(), _createElementBlock("b", _hoisted_27, _toDisplayString(board.Name), 1))
                              ], 64))
                            }), 128))
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", {
                      onClick: _cache[35] || (_cache[35] = () => { _ctx.showTags = true; })
                    }, "Tags"),
                    (_ctx.showTags)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createElementVNode("div", {
                            class: "board-item-tags-close",
                            onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.closeTags()))
                          }, [
                            _createVNode(_component_svg_icon, { icon: "x" })
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            (!_ctx.allTags.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, "This board has no tags yet. Add them from Edit Tags on the board."))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allTags, (tag, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: i,
                                class: "checkbox-input customer-request-tag",
                                style: _normalizeStyle('background:'+tag.color)
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  style: {"margin-left":"10px"},
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => ((tag.checked) = $event)
                                }, null, 8, _hoisted_33), [
                                  [_vModelCheckbox, tag.checked]
                                ]),
                                _createElementVNode("span", null, _toDisplayString(tag.name), 1)
                              ], 4))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", {
                      onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.showAddChecklistFn()))
                    }, "Checklist"),
                    (_ctx.showAddChecklist)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _createElementVNode("div", {
                            class: "board-item-tags-close",
                            onClick: _cache[38] || (_cache[38] = () => { _ctx.showAddChecklist = false })
                          }, [
                            _createVNode(_component_svg_icon, { icon: "x" })
                          ]),
                          _createElementVNode("form", {
                            onSubmit: _cache[40] || (_cache[40] = _withModifiers(($event: any) => (_ctx.addChecklist()), ["prevent"])),
                            class: "inline-plus-input"
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "input-slim",
                              "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.addChecklistInput) = $event)),
                              placeholder: "Add Checklist",
                              ref: "addChecklistInput"
                            }, null, 512), [
                              [_vModelText, _ctx.addChecklistInput]
                            ]),
                            _cache[79] || (_cache[79] = _createElementVNode("button", { class: "btn" }, [
                              _createElementVNode("span", null, "Add")
                            ], -1))
                          ], 32)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", {
                      onClick: _cache[41] || (_cache[41] = () => { _ctx.showDueDate = true; })
                    }, "Due Date"),
                    (_ctx.showDueDate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createElementVNode("div", {
                            class: "board-item-tags-close",
                            onClick: _cache[42] || (_cache[42] = () => { _ctx.showDueDate = false })
                          }, [
                            _createVNode(_component_svg_icon, { icon: "x" })
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            class: "input-slim",
                            style: {"margin":"0","width":"100%"},
                            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.formData.Date) = $event)),
                            onChange: _cache[44] || (_cache[44] = ($event: any) => (_ctx.fieldChange('due date')))
                          }, null, 544), [
                            [_vModelText, _ctx.formData.Date]
                          ]),
                          (_ctx.formData.Date)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                _createElementVNode("a", {
                                  style: {"cursor":"pointer","text-decoration":"underline"},
                                  onClick: _cache[45] || (_cache[45] = _withModifiers(() => { _ctx.formData.Date = null; _ctx.showDueDate = false; _ctx.fieldChange('due date'); }, ["prevent"]))
                                }, "Remove due date")
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              (_ctx.isTouchDevice())
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _cache[80] || (_cache[80] = _createElementVNode("div", { class: "crm-item-label" }, "Column", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.formData.Column) = $event)),
                      style: {"margin-bottom":"0"},
                      onChange: _cache[47] || (_cache[47] = ($event: any) => (_ctx.columnChange()))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: i,
                          value: column.name
                        }, _toDisplayString(column.name), 9, _hoisted_37))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, _ctx.formData.Column]
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _cache[84] || (_cache[84] = _createElementVNode("div", { class: "crm-item-label" }, "Description", -1)),
              (_ctx.editDescription)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_component_tip_tap, {
                        modelValue: _ctx.formData.Description,
                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.formData.Description) = $event)),
                        "hide-h3": true,
                        "hide-h4": true,
                        "hide-table": true
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", {
                        onClick: _cache[49] || (_cache[49] = () => { _ctx.fieldChange('description'); _ctx.editDescription = false; }),
                        class: "btn",
                        style: {"margin":"0"}
                      }, "Save")
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    (_ctx.formData.Description)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          (_openBlock(), _createBlock(_component_tip_tap, {
                            key: _ctx.descriptionVersion,
                            "model-value": _ctx.formData.Description,
                            "read-only": true
                          }, null, 8, ["model-value"]))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", {
                        onClick: _cache[50] || (_cache[50] = () => { _ctx.editDescription = true; }),
                        class: "btn",
                        style: {"margin":"0"}
                      }, _toDisplayString(_ctx.formData.Description ? 'Edit' : 'Add a description'), 1)
                    ])
                  ])),
              (_ctx.formData.ID)
                ? (_openBlock(), _createBlock(_component_forge_card_steps, {
                    key: 5,
                    card: { name: _ctx.formData.Name, description: _ctx.formData.Description, dueDate: _ctx.formData.Date, existingSteps: _ctx.formData.ChecklistJSON.flatMap((l) => l.items.map((it) => it.name)) },
                    onAdd: _ctx.addForgeSteps
                  }, null, 8, ["card", "onAdd"]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.ChecklistJSON, (list, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'list' + i
                }, [
                  _createElementVNode("div", _hoisted_44, [
                    _withDirectives(_createElementVNode("input", {
                      class: "h3-text-input",
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((list.name) = $event),
                      placeholder: "Enter Name",
                      onChange: ($event: any) => (_ctx.submitChecklist(false, list.name))
                    }, null, 40, _hoisted_45), [
                      [_vModelText, list.name]
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", {
                          onClick: ($event: any) => (_ctx.removeChecklist(i))
                        }, "Delete", 8, _hoisted_47)
                      ])
                    ])
                  ]),
                  (list.items.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        _createElementVNode("div", {
                          style: _normalizeStyle('width:' + _ctx.checklistPercent(list) + '%')
                        }, null, 4)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_draggable, {
                    list: list.items,
                    group: "checklist",
                    onChange: _cache[51] || (_cache[51] = ($event: any) => (_ctx.submitChecklist(false, null))),
                    class: "crm-board-checklist-checks",
                    handle: ".crm-checklist-handle",
                    animation: 150,
                    "ghost-class": "kanban-ghost"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.items, (item, j) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "checkbox-input",
                          key: j
                        }, [
                          _cache[81] || (_cache[81] = _createElementVNode("span", {
                            class: "crm-checklist-handle",
                            title: "Drag to reorder",
                            "aria-hidden": "true"
                          }, "⋮⋮", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => ((item.checked) = $event),
                            onChange: ($event: any) => (_ctx.submitChecklist(true, list.name))
                          }, null, 40, _hoisted_49), [
                            [_vModelCheckbox, item.checked]
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(item.checked ? 'crm-checklist-item-row checked' : 'crm-checklist-item-row')
                          }, [
                            _withDirectives(_createElementVNode("textarea", {
                              class: "inline-text-input",
                              rows: "1",
                              "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                              onChange: ($event: any) => (_ctx.submitChecklist(false, list.name))
                            }, null, 40, _hoisted_50), [
                              [_vModelText, item.name]
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                              _withDirectives(_createElementVNode("input", {
                                class: "text-input-no-style crm-checklist-date-input",
                                type: "date",
                                "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                                onChange: ($event: any) => (_ctx.submitChecklist(false, list.name))
                              }, null, 40, _hoisted_52), [
                                [_vModelText, item.date]
                              ]),
                              (!item.date)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_53, "Add date"))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("span", {
                              class: "crm-x",
                              title: "Remove item",
                              onClick: ($event: any) => (_ctx.removeChecklistItem(list, j))
                            }, [
                              _createVNode(_component_svg_icon, { icon: "x" })
                            ], 8, _hoisted_54)
                          ], 2)
                        ]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["list"]),
                  _withDirectives(_createElementVNode("form", {
                    onSubmit: _withModifiers(($event: any) => (_ctx.addChecklistItem(list, i)), ["prevent"]),
                    class: "inline-plus-input crm-checklist-add"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      id: _ctx.checklistInputID(i),
                      class: "input-slim",
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((list.addChecklistItemInput) = $event),
                      placeholder: "Add Checklist Item",
                      onKeyup: _withKeys(() => { list.showAddItem = false }, ["esc"])
                    }, null, 40, _hoisted_56), [
                      [_vModelText, list.addChecklistItemInput]
                    ]),
                    _cache[82] || (_cache[82] = _createElementVNode("button", { class: "btn" }, [
                      _createElementVNode("span", null, "Add")
                    ], -1))
                  ], 40, _hoisted_55), [
                    [_vShow, list.showAddItem]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_57, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn",
                      onClick: ($event: any) => (_ctx.listShowAddItem(list, i))
                    }, [...(_cache[83] || (_cache[83] = [
                      _createElementVNode("span", null, "Add an item", -1)
                    ]))], 8, _hoisted_58)
                  ], 512), [
                    [_vShow, !list.showAddItem]
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_59, [
                _cache[85] || (_cache[85] = _createElementVNode("div", { class: "crm-comments-header" }, [
                  _createElementVNode("b", null, "Comments")
                ], -1)),
                _createElementVNode("form", {
                  class: "crm-comment-form",
                  onSubmit: _cache[53] || (_cache[53] = _withModifiers(($event: any) => (_ctx.submitComment()), ["prevent"]))
                }, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.commentInput) = $event)),
                      placeholder: "Write a comment..."
                    }, null, 512), [
                      [_vModelText, _ctx.commentInput]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("input", {
                      class: _normalizeClass(_ctx.disableButtonComment ? 'disable-button btn' : 'btn'),
                      type: "submit",
                      value: "Save"
                    }, null, 2)
                  ])
                ], 32),
                (_ctx.comments.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comments, (comment, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "crm-comment",
                          key: i
                        }, [
                          (comment.edit)
                            ? (_openBlock(), _createElementBlock("form", {
                                key: 0,
                                class: "crm-comment-form",
                                style: {"margin-bottom":"10px"},
                                onSubmit: _withModifiers(($event: any) => (_ctx.submitCommentEdit(comment)), ["prevent"])
                              }, [
                                _createElementVNode("div", null, [
                                  _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": ($event: any) => ((comment.commentInput) = $event)
                                  }, null, 8, _hoisted_63), [
                                    [_vModelText, comment.commentInput]
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_64, [
                                  _createElementVNode("input", {
                                    class: _normalizeClass(_ctx.disableButtonComment ? 'disable-button btn' : 'btn'),
                                    type: "submit",
                                    value: "Save"
                                  }, null, 2)
                                ])
                              ], 40, _hoisted_62))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                innerHTML: comment.Comment
                              }, null, 8, _hoisted_65)),
                          _createElementVNode("div", _hoisted_66, [
                            (comment.CreatedBy)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_67, "- " + _toDisplayString(comment.CreatedBy), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_68, _toDisplayString(new Date(comment.DateCreated).toLocaleDateString(undefined, { dateStyle: 'short' })), 1),
                            (comment.CanEdit)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  onClick: _withModifiers(() => { comment.edit = !comment.edit }, ["prevent"])
                                }, _toDisplayString(comment.edit ? 'Close' : 'Edit'), 9, _hoisted_69))
                              : _createCommentVNode("", true),
                            (comment.CanDelete)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 2,
                                  class: "crm-x",
                                  title: "Delete comment",
                                  onClick: ($event: any) => (_ctx.deleteComment(comment))
                                }, [
                                  _createVNode(_component_svg_icon, {
                                    icon: "x",
                                    style: {"margin-left":"0"}
                                  })
                                ], 8, _hoisted_70))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_71, [
                _cache[86] || (_cache[86] = _createElementVNode("h3", null, "Files", -1)),
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", {
                      onClick: _cache[54] || (_cache[54] = () => { _ctx.showAddFile = !_ctx.showAddFile; _ctx.showAddLink = false })
                    }, "Add File")
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", {
                      onClick: _cache[55] || (_cache[55] = () => { _ctx.showAddFile = false; _ctx.showAddLink = !_ctx.showAddLink })
                    }, "Add Link")
                  ])
                ])
              ]),
              (_ctx.showAddFile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                    _createVNode(_component_drop_file, {
                      onFileChange: _ctx.onFileChange,
                      style: {"margin-bottom":"20px"}
                    }, null, 8, ["onFileChange"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showAddLink)
                ? (_openBlock(), _createElementBlock("form", {
                    key: 1,
                    onSubmit: _cache[58] || (_cache[58] = _withModifiers(($event: any) => (_ctx.submitLink()), ["prevent"])),
                    style: {"margin-bottom":"20px"}
                  }, [
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        class: "input-slim",
                        style: {"margin":"0 0 10px"},
                        type: "text",
                        "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.linkNameInput) = $event)),
                        placeholder: "Name"
                      }, null, 512), [
                        [_vModelText, _ctx.linkNameInput]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        class: "input-slim",
                        style: {"margin":"0"},
                        type: "text",
                        "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.linkURLInput) = $event)),
                        placeholder: "URL"
                      }, null, 512), [
                        [_vModelText, _ctx.linkURLInput]
                      ])
                    ]),
                    _cache[87] || (_cache[87] = _createElementVNode("div", {
                      class: "inline-plus-input",
                      style: {"margin-top":"10px"}
                    }, [
                      _createElementVNode("button", {
                        style: {"margin":"0 !important","font-size":"12px"},
                        class: "btn"
                      }, [
                        _createElementVNode("span", null, "Add")
                      ])
                    ], -1))
                  ], 32))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_74, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, i) => {
                  return (_openBlock(), _createElementBlock("div", { key: i }, [
                    (file.IsExternal)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: file.SpacesPath,
                          target: "_blank",
                          rel: "noopener"
                        }, _toDisplayString(file.Name), 9, _hoisted_75))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: _ctx.$store.state.apiUrl + _ctx.$store.state.spacesUrl + file.SpacesPath,
                          target: "_blank"
                        }, _toDisplayString(file.Name), 9, _hoisted_76)),
                    _createElementVNode("span", {
                      class: "crm-x",
                      title: "Remove file",
                      onClick: ($event: any) => (_ctx.deleteFile(file))
                    }, [
                      _createVNode(_component_svg_icon, { icon: "x" })
                    ], 8, _hoisted_77)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_78, [
                _cache[88] || (_cache[88] = _createElementVNode("h3", null, "Activity", -1)),
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", {
                      onClick: _cache[59] || (_cache[59] = () => { _ctx.showActivity = !_ctx.showActivity; })
                    }, _toDisplayString(_ctx.showActivity ? 'Hide' : 'Show'), 1)
                  ])
                ])
              ]),
              (_ctx.showActivity)
                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                    (!_ctx.activity.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_81, "No activity in the last 60 days."))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity, (a, i) => {
                      return (_openBlock(), _createElementBlock("div", { key: i }, [
                        _createElementVNode("div", _hoisted_82, _toDisplayString(a.DateDisplay), 1),
                        _createElementVNode("div", null, [
                          _createElementVNode("b", null, _toDisplayString(a.Username), 1),
                          _createTextVNode(" " + _toDisplayString(a.Text) + " " + _toDisplayString(_ctx.formData.Name), 1)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        (_ctx.showConfirmDelete)
          ? (_openBlock(), _createBlock(_component_confirm_delete, {
              key: 0,
              onConfirm: _ctx.deleteItemCB,
              onCancel: _cache[60] || (_cache[60] = () => { _ctx.showConfirmDelete = false; }),
              msg: _ctx.deleteMessage
            }, null, 8, ["onConfirm", "msg"]))
          : _createCommentVNode("", true),
        (_ctx.showConfirmRemoveChecklist)
          ? (_openBlock(), _createBlock(_component_confirm_delete, {
              key: 1,
              onConfirm: _ctx.removeChecklistCB,
              onCancel: _cache[61] || (_cache[61] = () => { _ctx.showConfirmRemoveChecklist = false; }),
              msg: "Are you sure you would like to delete this checklist?"
            }, null, 8, ["onConfirm"]))
          : _createCommentVNode("", true),
        (_ctx.showConfirmRemoveChecklistItem)
          ? (_openBlock(), _createBlock(_component_confirm_delete, {
              key: 2,
              onConfirm: _ctx.removeChecklistItemConfirm,
              onCancel: _cache[62] || (_cache[62] = () => { _ctx.showConfirmRemoveChecklistItem = false; }),
              msg: "Are you sure you would like to remove this checklist item?"
            }, null, 8, ["onConfirm"]))
          : _createCommentVNode("", true),
        (_ctx.showConfirmDeleteComment)
          ? (_openBlock(), _createBlock(_component_confirm_delete, {
              key: 3,
              onConfirm: _ctx.confirmCommentDelete,
              onCancel: _cache[63] || (_cache[63] = () => { _ctx.showConfirmDeleteComment = false; }),
              msg: "Are you sure you would like to delete this comment?"
            }, null, 8, ["onConfirm"]))
          : _createCommentVNode("", true),
        (_ctx.showConfirmFileDelete)
          ? (_openBlock(), _createBlock(_component_confirm_delete, {
              key: 4,
              onConfirm: _ctx.confirmFileDelete,
              onCancel: _cache[64] || (_cache[64] = () => { _ctx.showConfirmFileDelete = false; }),
              msg: "Are you sure you would like to remove this file?"
            }, null, 8, ["onConfirm"]))
          : _createCommentVNode("", true),
        (_ctx.showMoveLastColumnConfirm)
          ? (_openBlock(), _createBlock(_component_confirm_delete, {
              key: 5,
              onConfirm: _ctx.moveToLastColumn,
              onCancel: _cache[65] || (_cache[65] = () => { _ctx.showMoveLastColumnConfirm = false; }),
              msg: 'Are you sure you would like to move this card to ' + _ctx.lastColumn + '?'
            }, null, 8, ["onConfirm", "msg"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}